module.exports = __webpack_public_path__ + "static/lexus-7da7b1fb17958798aa9b7204214751b4.svg";